'use client';

import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const data = [
  { tag: '20.03', linkedin: 4, instagram: 2, x: 3, facebook: 1 },
  { tag: '21.03', linkedin: 6, instagram: 4, x: 2, facebook: 2 },
  { tag: '22.03', linkedin: 3, instagram: 5, x: 4, facebook: 0 },
  { tag: '23.03', linkedin: 8, instagram: 3, x: 5, facebook: 3 },
  { tag: '24.03', linkedin: 5, instagram: 6, x: 3, facebook: 1 },
  { tag: '25.03', linkedin: 7, instagram: 4, x: 6, facebook: 2 },
  { tag: '26.03', linkedin: 2, instagram: 2, x: 2, facebook: 1 },
  { tag: '27.03', linkedin: 9, instagram: 7, x: 4, facebook: 4 },
  { tag: '28.03', linkedin: 6, instagram: 5, x: 5, facebook: 2 },
  { tag: '29.03', linkedin: 4, instagram: 3, x: 3, facebook: 1 },
  { tag: '30.03', linkedin: 11, instagram: 8, x: 7, facebook: 5 },
  { tag: '31.03', linkedin: 7, instagram: 6, x: 4, facebook: 3 },
  { tag: '01.04', linkedin: 5, instagram: 4, x: 3, facebook: 2 },
  { tag: '02.04', linkedin: 9, instagram: 7, x: 6, facebook: 4 },
];

const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: Array<{ name: string; value: number; color: string }>; label?: string }) => {
  if (active && payload && payload.length) {
    return (
      <div className="punk-card p-3 text-xs shadow-glow min-w-[140px]">
        <p className="mono text-accent mb-2">{label}</p>
        {payload.map((entry) => (
          <div key={`tt-${entry.name}`} className="flex justify-between gap-4 mb-1">
            <span style={{ color: entry.color }}>{entry.name}</span>
            <span className="mono text-white font-600">{entry.value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default function DashboardActivityChart() {
  return (
    <div className="punk-card p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="section-label">Generierungsaktivität</p>
          <h3 className="text-sm font-600 text-white mt-1">Beiträge nach Plattform · letzte 14 Tage</h3>
        </div>
        <span className="status-badge bg-green-950/40 text-green-400 border border-green-800/40">
          <span className="w-1.5 h-1.5 rounded-full bg-green-400 pulse-orange" />
          Live
        </span>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="gradLI" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0A66C2" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#0A66C2" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gradIG" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#C13584" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#C13584" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gradX" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#aaa" stopOpacity={0.2} />
              <stop offset="95%" stopColor="#aaa" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gradFB" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1877F2" stopOpacity={0.25} />
              <stop offset="95%" stopColor="#1877F2" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#1A1A1A" strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="tag" tick={{ fill: '#444', fontSize: 10, fontFamily: 'IBM Plex Mono' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fill: '#444', fontSize: 10, fontFamily: 'IBM Plex Mono' }} axisLine={false} tickLine={false} />
          <Tooltip content={<CustomTooltip />} />
          <Area type="monotone" dataKey="linkedin" name="LinkedIn" stroke="#0A66C2" fill="url(#gradLI)" strokeWidth={1.5} dot={false} />
          <Area type="monotone" dataKey="instagram" name="Instagram" stroke="#C13584" fill="url(#gradIG)" strokeWidth={1.5} dot={false} />
          <Area type="monotone" dataKey="x" name="X" stroke="#aaa" fill="url(#gradX)" strokeWidth={1.5} dot={false} />
          <Area type="monotone" dataKey="facebook" name="Facebook" stroke="#1877F2" fill="url(#gradFB)" strokeWidth={1.5} dot={false} />
          <Legend
            iconType="line"
            iconSize={12}
            wrapperStyle={{ fontSize: '11px', fontFamily: 'IBM Plex Mono', color: '#666', paddingTop: '12px' }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}